import { forwardRef } from 'react';
import { lowerCase } from 'lodash';
import PropTypes from 'prop-types';

import { IconCloseThin } from 'src/assets/icons/CloseThin';
import { ChevronIcon } from 'src/components/ChevronIcon';
import { CustomIconButton } from 'src/components/CustomIconButton';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { ROTATE_DIRECTION } from 'src/data/ui';

import { getPromptMenuTypeLabel, PROMPT_MENU_TYPE } from '../../lib';

import { useStyles } from './useStyles';

const getTitle = (menuType, displayAlternativeTitle) => {
  if (menuType === PROMPT_MENU_TYPE.all) {
    return 'Search';
  }
  if (menuType === PROMPT_MENU_TYPE.salesforce) {
    return 'Search Salesforce';
  }
  if (menuType === PROMPT_MENU_TYPE.microsoftDynamicsSales) {
    return 'Search Microsoft Dynamics';
  }
  if (displayAlternativeTitle) {
    return `Add ${lowerCase(getPromptMenuTypeLabel(menuType)) || 'files and more'}`;
  }
  return `Add ${lowerCase(getPromptMenuTypeLabel(menuType))} to prompt`;
};

export const MenuHeader = forwardRef(
  ({ menuType, onChangeMenuType, onCloseMenu, displayAlternativeTitle }, ref) => {
    const styles = useStyles();

    const title = getTitle(menuType, displayAlternativeTitle);

    return (
      <div
        className={styles.root}
        ref={ref}
      >
        <div className={styles.titleWrapper}>
          <CustomTypography
            variant={TYPOGRAPHY_VARIANT.semiBold12}
            className={styles.title}
          >
            {menuType !== PROMPT_MENU_TYPE.default && (
              <CustomIconButton
                className={styles.buttonBack}
                data-testid="addToPromptMenuBackButton"
                onClick={() => onChangeMenuType(PROMPT_MENU_TYPE.default)}
              >
                <ChevronIcon direction={ROTATE_DIRECTION.left} />
              </CustomIconButton>
            )}

            {title}
          </CustomTypography>

          {menuType === PROMPT_MENU_TYPE.default && (
            <IconCloseThin
              className={styles.closeIcon}
              onClick={onCloseMenu}
            />
          )}
        </div>
      </div>
    );
  }
);

MenuHeader.propTypes = {
  menuType: PropTypes.string,
  onCloseMenu: PropTypes.func.isRequired,
  onChangeMenuType: PropTypes.func.isRequired,
  displayAlternativeTitle: PropTypes.bool,
};

MenuHeader.defaultProps = {
  menuType: '',
  displayAlternativeTitle: false,
};
